var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"title":_vm.title},on:{"close":function($event){_vm.$emit('close')}}},[_c('event-form',{attrs:{"event":_vm.event},on:{"saved":_vm.onSaved,"cancel":_vm.close}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6afa1e1a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/office/calendar/FormModal.vue
// module id = mfu9
// module chunks = 0